import { render, staticRenderFns } from "./PlateIntensityChart.vue?vue&type=template&id=5a712492&scoped=true"
import script from "./PlateIntensityChart.vue?vue&type=script&lang=js"
export * from "./PlateIntensityChart.vue?vue&type=script&lang=js"
import style0 from "./PlateIntensityChart.vue?vue&type=style&index=0&id=5a712492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a712492",
  null
  
)

export default component.exports